/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Filtersplaceholder1Inputs */

const id_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari game`)
};

const ms_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari permainan`)
};

const da_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter spil`)
};

const de_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche nach Spielen`)
};

const en_us2_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search for games`)
};

const es_es2_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar juegos`)
};

const es_mx2_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar juegos`)
};

const fil_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga laro`)
};

const fr_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des jeux`)
};

const it_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca giochi`)
};

const hu_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékok keresése`)
};

const nl_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek games`)
};

const no_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter spill`)
};

const pl_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj gier`)
};

const pt_br2_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar jogos`)
};

const pt_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar jogos`)
};

const ro_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută jocuri`)
};

const fi_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae pelejä`)
};

const sv_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök efter spel`)
};

const vi_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm game`)
};

const tr_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun ara`)
};

const cs_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat hry`)
};

const bg_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на игри`)
};

const ru_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск игр`)
};

const uk_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук ігор`)
};

const ar_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن ألعاب`)
};

const hi_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम खोजें`)
};

const th_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเกม`)
};

const ja_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームを検索`)
};

const zh_cn2_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索游戏`)
};

const zh_hant1_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋遊戲`)
};

const ko_search_filtersplaceholder1 = /** @type {(inputs: Search_Filtersplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 검색`)
};

/**
* | output |
* | --- |
* | "Search for games" |
*
* @param {Search_Filtersplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_filtersplaceholder1 = /** @type {((inputs?: Search_Filtersplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Filtersplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_filtersplaceholder1(inputs)
	if (locale === "ms") return ms_search_filtersplaceholder1(inputs)
	if (locale === "da") return da_search_filtersplaceholder1(inputs)
	if (locale === "de") return de_search_filtersplaceholder1(inputs)
	if (locale === "en-US") return en_us2_search_filtersplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_search_filtersplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_search_filtersplaceholder1(inputs)
	if (locale === "fil") return fil_search_filtersplaceholder1(inputs)
	if (locale === "fr") return fr_search_filtersplaceholder1(inputs)
	if (locale === "it") return it_search_filtersplaceholder1(inputs)
	if (locale === "hu") return hu_search_filtersplaceholder1(inputs)
	if (locale === "nl") return nl_search_filtersplaceholder1(inputs)
	if (locale === "no") return no_search_filtersplaceholder1(inputs)
	if (locale === "pl") return pl_search_filtersplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_search_filtersplaceholder1(inputs)
	if (locale === "pt") return pt_search_filtersplaceholder1(inputs)
	if (locale === "ro") return ro_search_filtersplaceholder1(inputs)
	if (locale === "fi") return fi_search_filtersplaceholder1(inputs)
	if (locale === "sv") return sv_search_filtersplaceholder1(inputs)
	if (locale === "vi") return vi_search_filtersplaceholder1(inputs)
	if (locale === "tr") return tr_search_filtersplaceholder1(inputs)
	if (locale === "cs") return cs_search_filtersplaceholder1(inputs)
	if (locale === "bg") return bg_search_filtersplaceholder1(inputs)
	if (locale === "ru") return ru_search_filtersplaceholder1(inputs)
	if (locale === "uk") return uk_search_filtersplaceholder1(inputs)
	if (locale === "ar") return ar_search_filtersplaceholder1(inputs)
	if (locale === "hi") return hi_search_filtersplaceholder1(inputs)
	if (locale === "th") return th_search_filtersplaceholder1(inputs)
	if (locale === "ja") return ja_search_filtersplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_filtersplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_filtersplaceholder1(inputs)
	return ko_search_filtersplaceholder1(inputs)
});
export { search_filtersplaceholder1 as "search.filtersPlaceholder" }